import React from 'react';
import { IProject } from "../types/Project.interface";

// Icons
import PortfolioIcon from '../assets/svg/logo.inline.svg';
import ConstructionIcon from '../assets/svg/construction.inline.svg';
import MoviesIcon from '../assets/svg/movies.inline.svg';
import GameIcon from '../assets/svg/game.inline.svg';

export const projects: IProject[] = [
    {
        // Config
        path: 'personal-website',

        // Gallery
        heroPrefix: 'portfolio-hero',
        galleryPrefix: 'portfolio-gallery',

        // Tile
        icon: <PortfolioIcon />,
        featured: true,
        title: 'Personal Website',

        // About 
        name: 'bravecode.eu',
        type: 'Personal',
        categories: ['Design', 'Development'],
        duration: 'One Month',

        // Description
        description: [
            'Creating a personal portfolio page has always been one of the biggest challenges for me, because it should be both visually attractive and, above all, legible. This is already its third version, and although the two previous versions were very well received, I was always missing something and I think that in this final version I included everything I wanted.',
            'As for the process of creating the website, it started with a paper and graphic design, which I made in Adobe XD. From a technical point of view, it was a long journey. I started to create the portfolio using the Svelte library and I was very impressed with it because of its simplicity and a slightly different approach, but I found that since I specialize in the React ecosystem, it would be a good idea to do a project using a new library related to it so I focused on two of them: Next and Gatsby. Ultimately choosing the latter because it was a small enough project that the static pages made more sense.',
            'I am happy with the result, the knowledge gained about both Svelte and Gatsby will pay off in the future. What could I have done better? Not change the technology in the middle of the project. With a site so small for the end-user, it hardly matters.'
        ],

        // Technologies
        technologies: {
            libraries: [
                'React',
                'Gatsby',
                'SCSS',
                'GCP & GSuite'
            ],
            languages: [
                {
                    name: 'Javascript',
                    color: '#26FDC3',
                    percentage: 50
                },
                {
                    name: 'HTML',
                    color: '#FF9E5E',
                    percentage: 20
                },
                {
                    name: 'CSS',
                    color: '#FD269D',
                    percentage: 20
                },
                {
                    name: 'Other',
                    color: '#161616',
                    percentage: 10
                }
            ]
        }
    },
    {
        // Config
        path: 'league-of-legends',

        heroPrefix: 'league-hero',
        galleryPrefix: 'league-gallery',

        // Tile
        icon: <GameIcon />,
        featured: false,
        title: 'League of Legends Client',

        // About 
        name: 'League of Legends Client',
        type: 'Personal',
        categories: ['Development'],
        duration: 'One Month',

        // Description
        description: [
            'The goal of this project was to improve my CSS styling skills. Since I like to play a good video game in my spare time, I thought why not combine the two. And so I created a copy of the League of Legends client.',
            'The biggest challenge of this project was to reproduce their client as precisely as possible without access to graphics, animations, or sound effects. Thanks to this project, I have certainly improved my knowledge of CSS, BEM naming conventions. It was also one of the first bigger private projects using React. Everything was connected to the back-end thanks to web sockets so you could chat with each other in real-time.',
            'I am pleased with the result of my work. Looking back, I could much better divide the application into modules and individual views.'
        ],

        // Technologies
        technologies: {
            libraries: [
                'React',
                'Node',
                'SCSS',
                'BEM',
                'Web Sockets',
                'Redux',
                'Express'
            ],
            languages: [
                {
                    name: 'Javascript',
                    color: '#26FDC3',
                    percentage: 30
                },
                {
                    name: 'HTML',
                    color: '#FF9E5E',
                    percentage: 30
                },
                {
                    name: 'CSS',
                    color: '#FD269D',
                    percentage: 30
                },
                {
                    name: 'Other',
                    color: '#161616',
                    percentage: 10
                }
            ]
        }
    },
    {
        // Config
        path: 'eogrodzenia',

        heroPrefix: 'ogrodzenia-hero',
        galleryPrefix: 'ogrodzenia-gallery',


        // Tile
        icon: <ConstructionIcon />,
        featured: false,
        title: 'Ogrodzenia',

        // About 
        name: 'Ogrodzenia',
        type: 'Commercial',
        categories: ['Design', 'Development'],
        duration: 'Two Weeks',

        // Description
        description: [
            'EOGRODZENIA was the first project from a client, which consisted of creating a company website that dealt with the installation of fences. The client was so pleased with the results that I received orders for two more projects.',
            'Each of the pages had its unique layout and was made with the use of a CMS. I caught up with my WordPress knowledge and learned the basics of SEO. In retrospect, there were many opportunities to improve SEO here, also if I had to choose the technology again, I would probably use Static Site Generator like Gatsby, because the client did not use the implemented blog function in the end.'
        ],

        // Technologies
        technologies: {
            libraries: [
                'HTML',
                'CSS',
                'SCSS',
                'WordPress'
            ],
            languages: [
                {
                    name: 'WordPress',
                    color: '#00749C',
                    percentage: 40
                },
                {
                    name: 'HTML',
                    color: '#FF9E5E',
                    percentage: 20
                },
                {
                    name: 'CSS',
                    color: '#FD269D',
                    percentage: 40
                }
            ]
        }
    },
    {
        // Config
        path: 'survival-game',

        // Gallery
        heroPrefix: 'survival-hero',
        galleryPrefix: 'survival-gallery',

        // Tile
        icon: <GameIcon />,
        featured: false,
        title: 'Survival Game',

        // About 
        name: 'Survival Game',
        type: 'Commercial',
        categories: ['Design', 'Development'],
        duration: 'Two Months',

        // Description
        description: [
            'Desiccated is an MMO game set in a post-apocalyptic world. I joined a team of 8 as a web developer and my goal was to create two websites. The first one presented the game, the second one - the studio and the team.',
            'To do my part, I have chosen the Laravel framework because of its clean and easy-to-understand documentation. The project also consisted of a simple forum function where players could present their ideas and follow upcoming changes.',
            'Even though I did my part of the job, unfortunately, the game project fell into oblivion. This project taught me to do more research on the company/team and not to sign contracts online on a sketchy website. But there are also some positive sides. I have improved my knowledge of MVC frameworks, which made my learning the Nest framework much easier.'
        ],

        // Technologies
        technologies: {
            libraries: [
                'Laravel',
                'SCSS',
                'PHP',
                'Javascript',
                'jQuery',
                'HTML',
                'Bootstrap'
            ],
            languages: [
                {
                    name: 'Laravel',
                    color: '#F05340',
                    percentage: 40
                },
                {
                    name: 'HTML',
                    color: '#FF9E5E',
                    percentage: 30
                },
                {
                    name: 'CSS',
                    color: '#FD269D',
                    percentage: 30
                }
            ]
        }
    },
    {
        // Route Config
        path: 'movie-streaming',

        // Gallery
        heroPrefix: 'movie-hero',
        galleryPrefix: 'movie-gallery',

        // Tile
        icon: <MoviesIcon />,
        featured: false,
        title: 'Movie Streaming',

        // About 
        name: 'Movie Fest',
        type: 'Personal',
        categories: ['Design', 'Development'],
        duration: 'One Week',

        // Description
        description: [
            `Movie Fest is a personal project with which I wanted to improve my UI / UX design skills. The initial plan was to create a graphic design only, but as a developer, I couldn't resist turning it into code. To create the project, I used regular static pages together with GULP, which was responsible for processing SCSS.`,
            'This project, later on, was submitted on 99designs for a design contest. I did not make it to the finals and this helped me to realize that I still have to learn a lot when it comes to graphics design.'
        ],

        // Technologies
        technologies: {
            libraries: [
                'HTML',
                'CSS',
                'Gulp',
                'Adobe Photoshop',
            ],
            languages: [
                {
                    name: 'HTML',
                    color: '#FF9E5E',
                    percentage: 30
                },
                {
                    name: 'CSS',
                    color: '#FD269D',
                    percentage: 60
                },
                {
                    name: 'Other',
                    color: '#161616',
                    percentage: 10
                }
            ]
        }
    }
];